import { createGetEndpoint } from '@sonar-software/sonar-http';
import { DataSecurityApplicationObject } from '@types';

export type GetDataSecurityApplicationFieldsRequest = {
	applicationId: number;
};

export type GetDataSecurityApplicationFieldsResponse = DataSecurityApplicationObject[];

export const getDataSecurityApplicationObjects = createGetEndpoint<
	GetDataSecurityApplicationFieldsRequest,
	GetDataSecurityApplicationFieldsResponse
>(({ applicationId }) => `/api/v3/data-security/applications/${applicationId}/sonar-objects`);
